<template functional>
  <vx-card
    title="ช่วงเวลาการเข้าเรียนของนิสิต"
    class="card-student-access-heatmap"
  >

    <div slot="no-body" class="p-4">
      
      <!-- Loader -->
      <div v-if="props.updating" class="loader w-full">
        <component name="student-access-loader" :is="injections.components.Loader" />
      </div>

      <div v-else>
        <div class="pl-10 w-full">          
          <component :is="injections.components.VueApexCharts"
            type="heatmap" height="140" width='100%'
            :series="$options.methods.heatmapSum(props.chartSeries)"
            :options="props.chartOptions.summary" />
        </div>

        <div class="w-full">          
          <component :is="injections.components.VueApexCharts"
            type="heatmap" :height="props.height" width='100%'
            :series="props.chartSeries"
            :options="props.chartOptions.byweek" />
        </div>
      </div>
    </div>

  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Loader from "@/components/common-ui/loader-block";

export default {
  inject: {
    components: {
      default: {
        VueApexCharts,
        Loader
      }
    },
  },
  props: {
    updating: {
      type: Boolean, default: true
    },
    chartOptions: {
      type: Object, default: null,
    },
    chartSeries: {
      type: Array, default: () => ([]),
    },
    height: {
      type: Number, default: 500
    }
  },
  methods: {
    heatmapSum(series) {
      const summary = [
        /* Series Structure */
        {
          name: "",
          data: [
            {
              "x": "TIME",
              "y": "SUM OF SAME DURATION OF 7 DAYS"
            }
          ]
        }
      ];

      let timeDuration = [];

      for (let day of series) {
        for (let i in day.data) {
          const data = day.data[i];
          const cursor = data.x;
          
          if (!timeDuration.some(time => time.x === cursor)) {
            timeDuration.push({ x: cursor, y: 0 })
          }

          const index = timeDuration.findIndex(time => {
            return time.x === cursor
          })
          
          if (timeDuration[index] && timeDuration[index].x === cursor) {
            timeDuration[index].y += data.y;
          }
          
        }
      }
      summary[0].data = timeDuration;

      return summary;
    }
  }
}
</script>

<style lang="scss" scoped>
.vx-card {
  min-height: 400px;
  
  & > .vs-con-loading__container {
    height: 100% !important;
  }
}
</style>
